import React, { useState, useEffect } from 'react';
import API from '../../api/axios';
import './Admin.css';

export default function AdminPhotosPage() {
    const [photos, setPhotos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [revealed, setRevealed] = useState({});

    const load = () => {
        setLoading(true);
        API.get('/api/admin/photos/pending')
            .then(res => setPhotos(res.data.photos || []))
            .finally(() => setLoading(false));
    };

    useEffect(() => { load(); }, []);

    const handleDecision = async (photoID, approved) => {
        await API.put(`/api/admin/photos/${photoID}`, { approved });
        setPhotos(prev => prev.filter(p => p.id !== photoID));
    };

    return (
        <div className="admin-page">
            <header className="admin-header">
                <h1>Flagged Photos ({photos.length})</h1>
            </header>

            {loading ? <div className="admin-loading">Loading...</div> : (
                <div className="photos-grid">
                    {photos.length === 0 && <p className="empty">No flagged photos.</p>}
                    {photos.map(photo => (
                        <div key={photo.id} className="photo-card">
                            <div
                                className={`photo-wrapper ${!revealed[photo.id] ? 'blurred' : ''}`}
                                onClick={() => setRevealed(r => ({ ...r, [photo.id]: true }))}
                            >
                                <img src={photo.url} alt="Flagged" />
                                {!revealed[photo.id] && (
                                    <div className="blur-overlay">Click to reveal</div>
                                )}
                            </div>
                            <div className="photo-meta">
                                <p>{photo.full_name || photo.email}</p>
                                {photo.moderation_labels && (
                                    <p className="labels">
                                        {JSON.parse(photo.moderation_labels)
                                            .map(l => `${l.name} (${l.confidence.toFixed(0)}%)`)
                                            .join(', ')}
                                    </p>
                                )}
                            </div>
                            <div className="photo-actions">
                                <button className="btn-approve" onClick={() => handleDecision(photo.id, true)}>
                                    ✓ Approve
                                </button>
                                <button className="btn-reject" onClick={() => handleDecision(photo.id, false)}>
                                    ✗ Reject
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}